<template>
  <div class="channelDetails">
    <el-dialog
      v-model="visible"
      width="85%"
      :before-close="Cancel"
      draggable
      class="editDetails"
    >
      <template #header>
        <div class="header">
          <h4>#{{ dialogueInfo.group_name }}</h4>
        </div>
      </template>
      <!-- <div class="topBox">
        <p @click="asterisk">
          <svg
            t="1698119798210"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5444"
            v-if="isAsterisk"
          >
            <path
              d="M512 760.224L298.944 918.08c-22.08 16.32-53.536 12.16-70.272-9.376a47.904 47.904 0 0 1-8-43.968l82.144-259.936-219.136-163.328a48.096 48.096 0 0 1-9.376-68.544c9.472-12.096 24.192-19.2 39.776-19.2l268.64-0.448 81.408-254.88c8.224-25.792 36.32-40.16 62.784-32.16 15.744 4.8 28.064 16.8 32.96 32.16l81.408 254.88 268.64 0.448c27.712 0.032 50.112 21.952 50.08 48.96 0 15.2-7.296 29.536-19.68 38.784l-219.136 163.328 82.144 259.936c8.16 25.792-6.688 53.184-33.152 61.12a51.2 51.2 0 0 1-45.12-7.776L512 760.224z"
              fill="#1296db"
              p-id="5445"
            />
          </svg>
          <svg
            t="1698119798210"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5444"
            v-else
          >
            <path
              d="M512 760.224L298.944 918.08c-22.08 16.32-53.536 12.16-70.272-9.376a47.904 47.904 0 0 1-8-43.968l82.144-259.936-219.136-163.328a48.096 48.096 0 0 1-9.376-68.544c9.472-12.096 24.192-19.2 39.776-19.2l268.64-0.448 81.408-254.88c8.224-25.792 36.32-40.16 62.784-32.16 15.744 4.8 28.064 16.8 32.96 32.16l81.408 254.88 268.64 0.448c27.712 0.032 50.112 21.952 50.08 48.96 0 15.2-7.296 29.536-19.68 38.784l-219.136 163.328 82.144 259.936c8.16 25.792-6.688 53.184-33.152 61.12a51.2 51.2 0 0 1-45.12-7.776L512 760.224z"
              fill="rgba(var(--sk_primary_foreground, 29, 28, 29), 0.3)"
              p-id="5445"
            />
          </svg>
        </p>
      </div>-->
      <div class="modal_content">
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('slack.About')" name="about">
            <el-scrollbar style="height: 300px">
              <div class="groupBox">
                <div class="group">
                  <h3 class="title">{{ $t("slack.Channelname") }}</h3>
                  <p class="text"># {{ dialogueInfo.group_name }}</p>
                  <el-link
                    type="primary"
                    @click="editClick"
                    v-if="userInfo.nickname == creator"
                  >{{ $t("slack.Edit") }}</el-link>
                </div>
              </div>
              <div class="groupBox">
                <div class="group">
                  <h3 class="title">{{ $t("slack.description") }}</h3>
                  <p class="text">{{ dialogueInfo.description }}</p>
                  <el-link
                    type="primary"
                    @click="setConfig('isEditdescribe')"
                    v-if="userInfo.nickname == creator"
                  >{{ $t("slack.Edit") }}</el-link>
                </div>
                <div class="group solid">
                  <h3 class="title">{{ $t("slack.createUser") }}</h3>
                  <p class="text jc-sb" style="display: flex">
                    <span>{{ creator }}</span>
                    <span>{{ create_time }}</span>
                  </p>
                </div>
                <div class="group solid">
                  <h3
                    style="color: rgba(var(--sk_raspberry_red, 224, 30, 90), 1)"
                    v-if="userInfo.nickname == creator"
                    @click="dissolvegroup"
                  >{{ $t("slack.delete") }}</h3>
                  <h3
                    style="color: rgba(var(--sk_raspberry_red, 224, 30, 90), 1)"
                    @click="exitgroup"
                    v-else
                  >{{ $t("slack.exit") }}</h3>
                </div>
              </div>
            </el-scrollbar>
          </el-tab-pane>
          <el-tab-pane :label="$t('slack.Member')" name="member">
            <div style="height: 300px">
              <el-input
                v-model="user"
                :placeholder="SearchText"
                clearable
                style="padding: 0px 20px"
                @input="FindPeople"
              >
                <template #prefix>
                  <el-icon class="el-input__icon">
                    <search />
                  </el-icon>
                </template>
                <!-- <template #append>
                  <el-button :icon="Search" @click="FindPeople" />
                </template>-->
              </el-input>
              <div class="addBtn group" @click="addUser">
                <button>
                  <svg
                    t="1680854921807"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2126"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M986.547801 768.377371H840.487724V622.297301c0-18.263758-14.605008-36.517518-36.517519-36.517519s-36.517518 14.605008-36.517518 36.517519v146.08007H621.372617c-18.263758 0-36.517518 14.605008-36.517519 36.517518s14.605008 36.517518 36.517519 36.517519h146.08007v146.070074c0 18.263758 14.605008 36.517518 36.517518 36.517518s36.517518-14.615005 36.517519-36.517518V841.412408h146.070074c18.263758 0 36.517518-14.615005 36.517518-36.517519 0-21.91251-14.615005-36.517518-36.527515-36.517518z m-182.587592-474.737736C803.960209 132.954557 672.495143 1.489491 511.820062 1.489491 351.14498 1.489491 219.679914 132.954557 219.679914 293.639635c0 102.245053 51.122526 193.543847 131.465066 244.666374C146.634881 604.04354 0.564807 797.587387 0.564807 1024h73.035037c0-241.017621 197.202597-438.220218 438.220218-438.220218 160.675082 0.009997 292.140147-131.465066 292.140147-292.140147zM511.820062 512.744745c-120.50881 0-219.105111-98.5963-219.105111-219.10511 0-120.50881 98.5963-219.115107 219.105111-219.115107C632.328872 74.524528 730.925172 173.130824 730.925172 293.639635s-98.5963 219.105111-219.10511 219.10511z m0 0"
                      fill="rgba(var(--sk_highlight, 18, 100, 163), 1)"
                      p-id="2127"
                    />
                  </svg>
                </button>
                <span>{{ $t("slack.adduser") }}</span>
              </div>
              <el-scrollbar style="height: 210px">
                <div
                  class="group member"
                  v-for="(item, index) in memberList"
                  :key="index"
                  @dblclick="Privatechat(item)"
                >
                  <img v-if="item.HeadPhotoUrl" :src="item.HeadPhotoUrl" />
                  <strong>{{ item.nickname }}</strong>
                  <el-link
                    type="primary"
                    v-if="
                      userInfo.user_uid == creator_id && item.nickname != creator
                    "
                    @click="exitgroup1(item, index)"
                  >{{ $t("slack.remove") }}</el-link>
                </div>
              </el-scrollbar>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!-- 修改频道名称 -->
    <el-dialog
      v-model="channelNamedialog"
      width="400px"
      align-center
      :before-close="channelNameCancel"
    >
      <template #header>
        <div class="header">
          <h4>{{ $t("slack.Channelname") }}</h4>
        </div>
      </template>
      <div class="modal_content">
        <!-- <p class="text">{{ $t("slack.Channelname") }}</p> -->
        <div class="inputBox">
          <el-input
            v-model="group_name"
            :placeholder="ChannelnameText"
            maxlength="20"
            show-word-limit
          />
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="channelNamedialog = false">
            {{
            $t("slack.Cancel")
            }}
          </el-button>
          <el-button type="primary" @click="groupedit">
            {{
            $t("slack.Confirm")
            }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 邀请人员加入群聊 -->
    <el-dialog
      v-model="addDialog"
      width="400px"
      class="addUser"
      :before-close="adduserCancel"
    >
      <template #header>
        <div class="header">
          <h4>{{ $t("slack.adduser") }}</h4>
          <p class="hintText"># {{ dialogueInfo.group_name }}</p>
        </div>
      </template>
      <div class="modal_content">
        <div class="inputBox">
          <el-select
            v-model="userID"
            :placeholder="SelectText"
            filterable
            collapse-tags
            multiple
            ref="group_User"
            :filter-method="filterUsers"
            popper-class="selectUser"
          >
            <el-option
              v-for="item in allusers"
              :key="item.user_uid"
              :label="item.nickname"
              :value="item.user_uid"
              :disabled="item.disabled"
            >
              <span style="float: left">{{ item.nickname }}</span>
              <el-icon v-if="item.disabled" class="select_icon">
                <Check />
              </el-icon>
            </el-option>
          </el-select>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="addDialog = false">
            {{
            $t("slack.Cancel")
            }}
          </el-button>
          <el-button type="primary" @click="JoinGroup">
            {{
            $t("slack.Confirm")
            }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { HomeStore } from "../index";
import * as $axios from "../api/index";
import { parseTime, extend, debounce } from "../utils";
import { ElMessage, ElMessageBox } from "element-plus";
import { Search } from "@element-plus/icons-vue";
import { shallowRef } from "vue";
import { useDemoStore } from "@/pinia/index.js";
export default {
  data() {
    return {
      visible: false,
      channelNamedialog: false,
      addDialog: false,
      user: "",
      activeName: "about",
      memberList: [], //群聊人员列表
      memberList1: [], //保存全部的人员
      creator: "", //创建者
      creator_id: "",
      group_name: "", //频道名称
      userID: [],
      allusers: [],
      Search: shallowRef(Search),
      create_time: "",
      isAsterisk: false,
      SelectText: useDemoStore().lang == "en-us" ? "Select User" : "选择用户",
      SearchText: useDemoStore().lang == "en-us" ? "Search User" : "搜索用户",
      ChannelnameText:
        useDemoStore().lang == "en-us"
          ? "Please enter the Channel Name"
          : "请输入频道名称",
    };
  },
  computed: {
    ischannelDetails() {
      return HomeStore().setting.ischannelDetails;
    },
    dialogueInfo() {
      return HomeStore().setting.dialogueInfo;
    },
    userInfo() {
      return HomeStore().userInfo;
    },
  },
  watch: {
    ischannelDetails(val) {
      this.isAsterisk = false;
      this.visible = val;
      this.user = "";
      this.activeName = HomeStore().setting.channelDetailName;
      let index = HomeStore().AsteriskList.findIndex((item) => {
        return item.group_id == this.dialogueInfo.group_id;
      });
      if (index >= 0) {
        this.isAsterisk = true;
      }
      if ("group_id" in this.dialogueInfo && val) {
        $axios
          .groupinfo({
            token: HomeStore().token,
            group_id: this.dialogueInfo.group_id,
          })
          .then((res) => {
            res.data.info.map((item) => {
              item.user_uid = item.user_id;
            });
            this.memberList = extend(res.data.info, true);
            this.memberList1 = extend(res.data.info, true);
            this.creator = res.data.leader.nickname;
            this.creator_id = res.data.leader.user_id;
            if (useDemoStore().lang == "en-us") {
              this.create_time = parseTime(
                res.data.leader.create_time,
                "{m}-{d}-{y} {h}:{i}:{s}"
              );
            }
            if (useDemoStore().lang == "zh-cn") {
              this.create_time = parseTime(res.data.leader.create_time);
            }
          });
      }
      if (!val) {
        this.userID = [];
      }
    },
  },
  methods: {
    //弹窗关闭
    channelNameCancel() {
      if (this.group_name != this.dialogueInfo.group_name) {
        if (useDemoStore().lang == "en-us") {
          ElMessageBox.confirm(
            "Edited information not been saved yet. Are you sure to leave?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => {
              this.channelNamedialog = false;
            })
            .catch(() => {});
        }
        if (useDemoStore().lang == "zh-cn") {
          ElMessageBox.confirm(
            "已编辑的信息尚未保存。你确定要离开吗?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              this.channelNamedialog = false;
            })
            .catch(() => {});
        }
      } else {
        this.channelNamedialog = false;
      }
    },
    //收藏频道
    asterisk() {
      this.isAsterisk = !this.isAsterisk;
      if (this.isAsterisk) {
        $axios
          .asterisk({
            token: HomeStore().token,
            type: "set",
            group_id: this.dialogueInfo.group_id,
          })
          .then(() => {
            let index = HomeStore().channelList.findIndex((item) => {
              return item.group_id == this.dialogueInfo.group_id;
            });
            HomeStore().AsteriskList.unshift(HomeStore().channelList[index]);
            HomeStore().menuIndex += 1;
            if (useDemoStore().lang == "en-us") {
              ElMessage({
                type: "success",
                message: "success",
              });
            } else {
              ElMessage({
                type: "success",
                message: "成功",
              });
            }
          });
      } else {
        let index = HomeStore().AsteriskList.findIndex((item) => {
          return item.group_id == this.dialogueInfo.group_id;
        });
        $axios
          .asterisk({
            token: HomeStore().token,
            type: "remove",
            group_id: HomeStore().AsteriskList[index].group_id,
          })
          .then(() => {
            if (useDemoStore().lang == "en-us") {
              ElMessage({
                type: "success",
                message: "success",
              });
            } else {
              ElMessage({
                type: "success",
                message: "成功",
              });
            }
            HomeStore().AsteriskList.splice(index, 1);
            HomeStore().menuIndex -= 1;
            if (
              HomeStore().menuIndex <=
              HomeStore().AsteriskList.length +
                HomeStore().conversationObjectList.length
            ) {
              let item = HomeStore().channelList[0];
              HomeStore().setConfig("dialogueInfo", {
                group_name: item.group_name,
                description: item.description,
                type: 2,
                group_id: item.group_id,
              });
              HomeStore().menuIndex =
                HomeStore().AsteriskList.length +
                HomeStore().conversationObjectList.length +
                1;
              HomeStore().getgroupchat(item);
              this.visible = false;
              HomeStore().setConfig("ischannelDetails", false);
              HomeStore().Chatobject = "channel";
              if (item.unread > 0) {
                $axios
                  .groupread({
                    token: HomeStore().token,
                    group_id: item.group_id,
                    readtype: "read",
                  })
                  .then(() => {
                    HomeStore().getunReadMsgCount();
                  });
                HomeStore().channelList[0].unread = 0;
              }
            }
          });
      }
    },
    Cancel() {
      HomeStore().setConfig("ischannelDetails", false);
      HomeStore().channelNum = this.memberList1.length;
    },
    setConfig(val) {
      HomeStore().setConfig(val, true);
    },
    //获取下拉用户
    getUser(userList, allusers) {
      let Ids = [];
      userList.map((item) => {
        Ids.push(String(item.user_id));
      });
      allusers.map((item) => {
        if (Ids.indexOf(String(item.user_uid)) != -1) {
          item.disabled = true;
        }
      });
      this.allusers = allusers;
    },
    filterUsers: debounce(function (val) {
      if (!val) {
        // this.getUser(this.memberList1, HomeStore().allusers);
        return;
      }
      $axios
        .allusers({
          token: HomeStore().token,
          keywords: val,
        })
        .then((res) => {
          this.getUser(this.memberList1, res.data);
        });
    }, 500),
    //查找人员
    FindPeople() {
      this.memberList = this.memberList1.filter((item) => {
        return (
          item.nickname
            .toLocaleLowerCase()
            .indexOf(this.user.toLocaleLowerCase()) != -1
        );
      });
    },
    //邀请用户加入
    JoinGroup() {
      if (this.userID.length == 0) {
        if (useDemoStore().lang == "en-us") {
          ElMessage({
            type: "info",
            message: "Please Select User",
          });
        } else {
          ElMessage({
            type: "info",
            message: "请选择用户",
          });
        }
        return;
      }
      this.userID.map((item) => {
        let data = {
          type: "JoinGroup",
          token: HomeStore().token,
          to_uid: item,
          group_id: HomeStore().setting.dialogueInfo.group_id,
          // client_id: HomeStore().client_id,
        };
        console.log(data);
        HomeStore().socket.send(JSON.stringify(data));
      });
      $axios
        .allusers({
          token: HomeStore().token,
          user_uid: this.userID,
        })
        .then((res) => {
          res.data.map((item) => {
            item.user_id = item.user_uid;
            if (this.userID.indexOf(item.user_uid) != -1) {
              this.memberList.unshift(item);
            }
          });
          this.userID = [];
          this.memberList1 = extend(this.memberList, true);
          HomeStore().channelNum = this.memberList1.length;
        });

      this.addDialog = false;
      if (useDemoStore().lang == "en-us") {
        ElMessage({
          type: "success",
          message: "success",
        });
      } else {
        ElMessage({
          type: "success",
          message: "成功",
        });
      }
    },
    //邀请用户加入取消事件
    adduserCancel() {
      if (this.userID.length > 0) {
        if (useDemoStore().lang == "en-us") {
          ElMessageBox.confirm(
            "Edited information not been saved yet. Are you sure to leave?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => {
              this.addDialog = false;
              this.userID = [];
            })
            .catch(() => {});
        } else {
          ElMessageBox.confirm(
            "已编辑的信息尚未保存。你确定要离开吗?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              this.addDialog = false;
              this.userID = [];
            })
            .catch(() => {});
        }
      } else {
        this.addDialog = false;
        this.userID = [];
      }
    },
    //邀请用户的弹窗
    addUser() {
      let friendList = extend(HomeStore().friends, true);
      friendList.map((item) => {
        item.nickname = item.receiver_name;
      });
      HomeStore().allusers.map((item) => {
        let index = friendList.findIndex((friend) => {
          return friend.user_uid == item.user_uid;
        });
        if (index == -1) {
          friendList.push(item);
        }
      });
      this.getUser(this.memberList1, friendList);
      this.addDialog = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs["group_User"].focus();
        }, 500);
      });
      $axios
        .allusers({
          token: HomeStore().token,
          pageNo: 1,
          pageSize: 30,
        })
        .then((res) => {
          HomeStore().allusers = res.data;
        });
    },
    //私聊
    Privatechat(val) {
      let index = HomeStore().friends.findIndex((item) => {
        return item.user_uid == val.user_uid;
      });
      HomeStore().setConfig("ischannelDetails", false);
      $axios
        .getfriendAddress({
          token: HomeStore().token,
          friend_id: val.user_uid,
        })
        .then((res) => {
          if (res.data) {
            HomeStore().user_host = res.data.user_host;
          }
        });
      if (index == -1) {
        $axios
          .addfriends({
            token: HomeStore().token,
            to_id: [val.user_uid],
          })
          .then((res) => {
            let val = res.data[res.data.length - 1];
            res.data.map((item) => {
              HomeStore().isError[item.user_uid] = "";
              item.HeadPhotoUrl = item.profile_photo;
              item.user_avatar_file_name = item.profile_photo;
              item.receiver_name = item.nickname;
              item.unread = 0;
              item.receiver_id = item.user_uid;
              HomeStore().friends.unshift(item);
              HomeStore().chatMessageList[item.user_uid] = [];
              HomeStore().isNeedQuery[item.user_uid] = true;
              HomeStore().IsPrivatechat = {
                user_uid: item.user_uid,
              };
            });
          });
      } else {
        HomeStore().IsPrivatechat = {
          user_uid: HomeStore().friends[index].user_uid,
        };
      }
    },
    //修改频道事件
    editClick() {
      this.group_name = this.dialogueInfo.group_name;
      this.channelNamedialog = true;
    },
    //修改群聊消息
    groupedit() {
      $axios
        .groupedit({
          token: HomeStore().token,
          group_id: this.dialogueInfo.group_id,
          group_name: this.group_name,
        })
        .then(() => {
          if (useDemoStore().lang == "en-us") {
            ElMessage({
              type: "success",
              message: "success",
            });
          } else {
            ElMessage({
              type: "success",
              message: "成功",
            });
          }
          HomeStore().setting.dialogueInfo.group_name = this.group_name;
          let index = HomeStore().channelList.findIndex((item) => {
            return item.group_id == this.dialogueInfo.group_id;
          });
          HomeStore().channelList[index].group_name = this.group_name;
        })
        .finally(() => {
          this.channelNamedialog = false;
        });
    },
    //解散群聊
    dissolvegroup() {
      let ElMessageBoxText =
        useDemoStore().lang == "zh-cn"
          ? "您确定要删除此频道吗?"
          : "Are you sure you want to delete this channel?";
      let WarningText = useDemoStore().lang == "zh-cn" ? "提示" : "Warning";
      let OKText = "zh-cn" ? "确定" : "OK";
      let CancelText = "zh-cn" ? "取消" : "Cancel";
      let infoText = "zh-cn" ? "删除成功!" : "Delete completed!";

      ElMessageBox.confirm(ElMessageBoxText, WarningText, {
        confirmButtonText: OKText,
        cancelButtonText: CancelText,
        type: "warning",
      })
        .then(() => {
          $axios
            .dissolvegroup({
              token: HomeStore().token,
              group_id: this.dialogueInfo.group_id,
            })
            .then(() => {
              ElMessage({
                type: "success",
                message: infoText,
              });
              HomeStore().IsDelPrivatechat = {
                group_id: this.dialogueInfo.group_id,
              };
              this.visible = false;
              HomeStore().setConfig("ischannelDetails", false);
              let index = HomeStore().channelList.findIndex((item) => {
                return item.group_id == this.dialogueInfo.group_id;
              });
              HomeStore().channelList.splice(index, 1);
            });
        })
        .catch(() => {});
    },
    //退出频道
    exitgroup() {
      let ElMessageBoxText =
        useDemoStore().lang == "zh-cn"
          ? "您确定要退出此频道吗?"
          : "Are you sure you want to exit this channel?";
      let WarningText = useDemoStore().lang == "zh-cn" ? "提示" : "Warning";
      let OKText = "zh-cn" ? "确定" : "OK";
      let CancelText = "zh-cn" ? "取消" : "Cancel";
      let infoText = "zh-cn" ? "成功" : "success";

      ElMessageBox.confirm(ElMessageBoxText, WarningText, {
        confirmButtonText: OKText,
        cancelButtonText: CancelText,
        type: "warning",
      })
        .then(() => {
          $axios
            .exitgroup({
              token: HomeStore().token,
              group_id: this.dialogueInfo.group_id,
            })
            .then(() => {
              ElMessage({
                type: "success",
                message: infoText,
              });
              HomeStore().IsDelPrivatechat = {
                group_id: this.dialogueInfo.group_id,
              };
              let index = HomeStore().channelList.findIndex((item) => {
                return item.group_id == this.dialogueInfo.group_id;
              });
              HomeStore().channelList.splice(index, 1);
              this.visible = false;
              HomeStore().setConfig("ischannelDetails", false);
            });
        })
        .catch(() => {});
    },
    //移出频道
    exitgroup1(item, index) {
      let ElMessageBoxText =
        useDemoStore().lang == "zh-cn"
          ? "您确定要删除该用户吗?"
          : "Are you sure you want to remove the user?";
      let OKText = useDemoStore().lang == "zh-cn" ? "确定" : "OK";
      let CancelText = useDemoStore().lang == "zh-cn" ? "取消" : "Cancel";
      let infoText = useDemoStore().lang == "zh-cn" ? "成功" : "success";
      ElMessageBox.confirm(ElMessageBoxText, {
        confirmButtonText: OKText,
        cancelButtonText: CancelText,
        type: "warning",
      })
        .then(() => {
          $axios
            .exitgroup({
              token: HomeStore().token,
              group_id: this.dialogueInfo.group_id,
              to_uid: item.user_uid,
            })
            .then(() => {
              ElMessage({
                type: "success",
                message: infoText,
              });
              this.memberList.splice(index, 1);
              this.memberList1.splice(index, 1);
              HomeStore().channelNum = this.memberList1.length;
            });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less">
.channelDetails {
  .header {
    h4 {
      font-size: 18px;
      font-weight: 900;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .hintText {
      font-size: 13px;
      font-weight: 400;
      margin-top: 4px;
    }
  }
  .topBox {
    margin-left: 20px;
    cursor: pointer;
    p {
      width: 40px;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(var(--sk_primary_background, 255, 255, 255), 1);
      border: solid 1px rgba(var(--sk_primary_foreground, 29, 28, 29), 0.3);
      border-radius: 4px;
    }
    svg {
      width: 15px;
      height: 22px;
    }
  }
  .editDetails {
    .el-dialog__header {
      padding: 10px 20px;
    }
  }

  .el-dialog__headerbtn {
    top: 1px !important;
  }
  .editDetails {
    padding: 0 !important;
  }
  .el-dialog__body {
    .modal_content {
      color: rgba(var(--sk_primary_foreground, 29, 28, 29), 1);
      .groupBox {
        margin: 0 20px;
        --saf-0: rgba(var(--sk_foreground_low, 29, 28, 29), 0.13);
        border-radius: 12px;
        border: 1px solid var(--saf-0);
        background: rgba(var(--sk_primary_background, 255, 255, 255), 1);
        cursor: pointer;
        position: relative;
        margin-bottom: 16px;
        .group {
          .title {
            font-weight: 700;
            color: #000;
          }
          .text {
            font-size: 15px;
            margin-top: 8px;
            font-weight: 400;
            display: inline-block;
            max-width: 100%;
            // white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .el-link {
            position: absolute;
            right: 20px;
            top: 16px;
          }
        }

        .solid {
          border-top: 1px solid rgba(var(--sk_foreground_low, 29, 28, 29), 0.13);
        }
      }
      .el-tabs__header {
        padding: 0 20px;
        margin: 0 0 10px0 !important;
      }
      .group {
        padding: 10px 20px;
      }
      .group:hover {
        background: rgba(var(--sk_foreground_min, 29, 28, 29), 0.04);
      }
      .member {
        display: flex;
        align-items: center;
        font-size: 16px;
        position: relative;
        cursor: pointer;
        border-bottom: solid 1px
          rgba(var(--sk_foreground_low_solid, 221, 221, 221), 1);
        img {
          height: 36px;
          width: 36px;
          border-radius: 4px;
          margin-right: 12px;
        }
        .el-link {
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          opacity: 0;
        }
      }
      .member:hover {
        .el-link {
          opacity: 1;
        }
      }
      .text {
        font-size: 15px;
        font-weight: 700;
        color: #000000;
      }
      .hintText {
        color: rgba(var(--sk_foreground_max_solid, 97, 96, 97), 1);
        font-size: 13px;
        font-weight: 400;
        line-height: 1.38461538;
        margin-top: 4px;
        margin-bottom: 7px;
      }
      .addBtn {
        font-weight: 700;
        font-size: 15px;
        color: rgba(var(--sk_primary_foreground, 29, 28, 29), 1);
        cursor: pointer;
        display: flex;
        align-items: center;
        button {
          background: #1d9bd11a;
          color: rgba(var(--sk_highlight, 18, 100, 163), 1);
          border-radius: 4px;
          height: 36px;
          margin-right: 12px;
          width: 36px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: none;
          cursor: pointer;
          margin-right: 12px;
        }
      }
    }
  }
}
.el-tooltip__popper {
  max-width: 90vw;
}
.selectUser {
  .select_icon {
    position: absolute;
    font-size: 12px;
    right: 20px;
    top: 10px;
    color: #409eff;
  }
}
</style>
